export const rbacRTTI = Symbol.for("Rbac");
